"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elog = require("./elog");
function setItem(key, value) {
    try {
        var serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
        return true;
    }
    catch (error) {
        elog.error('Local Storage set error', {}, error);
        return false;
    }
}
exports.setItem = setItem;
function getItem(key, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = null; }
    try {
        var storedValue = localStorage.getItem(key);
        return JSON.parse(storedValue) || fallbackValue;
    }
    catch (error) {
        elog.error('Local Storage get error', {}, error);
        localStorage.removeItem(key);
        return fallbackValue;
    }
}
exports.getItem = getItem;
//# sourceMappingURL=local_storage_utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/local_storage_utils.js
// module id = 8seA
// module chunks = 20 21